import ScrollBooster from 'scrollbooster';

export default function () {
  document.addEventListener('DOMContentLoaded', function(event) {
    const targetButton = document.getElementById('submit');
    const triggerCheckbox = document.querySelector('input[name="agree"]');
    const triggerAgreeCheckbox = document.getElementById('agree_send_id');
    const check = document.getElementById('chkbox');
    const checkAgree = document.getElementById('agree_chkbox');
    targetButton.disabled = true;
    targetButton.classList.add('is-inactive');

    triggerCheckbox.addEventListener('change', function() {
      if (this.checked) {
        check.classList.add('is-active');
      } else {
        check.classList.remove('is-active');
      }
    }, false);

    if (triggerAgreeCheckbox) {
      triggerAgreeCheckbox.addEventListener('change', function() {
        if (this.checked) {
          checkAgree.classList.add('is-active');
        } else {
          checkAgree.classList.remove('is-active');
        }
      }, false);
    }
    const requriedElements = document.querySelectorAll('.required');
    requriedElements.forEach(function(element){
      element.addEventListener('input', function(e){
        if(
          document.querySelector('.req-slct').value !== ''
          && document.querySelector('input[name="name"]').value !== ''
          && document.querySelector('input[name="email"]').value !== ''
          && document.querySelector('textarea[name="memo"]').value !== ''
          && document.querySelector('input[name="agree"]').checked
        ) {
          targetButton.disabled = false;
          targetButton.classList.remove('is-inactive');
          targetButton.classList.add('is-active');
        } else {
          targetButton.disabled = true;
          targetButton.classList.remove('is-active');
          targetButton.classList.add('is-inactive');
        }
      }, false);
    });
  }, false);

  $('.privacy-link').click(function(event) {
    console.log("LINK CLICKED");
    event.stopPropagation();
  });

  $('#chk-trigger').click(function() {
    if ($(event.target).closest('.privacy-link').length === 0) {
      $('#chkbox').toggleClass('is-active');
      if ($('#chkbox input').prop('checked')) {
        $('#chkbox input').prop('checked', false);
        handleInactiveButtonSubmit();
      } else {
        $('#chkbox input').prop('checked', true);
        handleInactiveButtonSubmit();
      }
    }
  })
  $('#chk-trigger-send-mail').click(function() {
    $('#agree_chkbox').toggleClass('is-active');
    if ($('#agree_chkbox input').prop('checked')) {
      $('#agree_chkbox input').prop('checked', false);
    } else {
      $('#agree_chkbox input').prop('checked', true);
    }
  })

  /**
   * Enable or disable the submit button based on whether all required input fields are filled.
   * @function
   */
  function handleInactiveButtonSubmit() {
    const targetButton = document.getElementById('submit');
    targetButton.disabled = true;
    targetButton.classList.add('is-inactive');
    if(
      document.querySelector('.req-slct').value !== ''
      && document.querySelector('input[name="name"]').value !== ''
      && document.querySelector('input[name="email"]').value !== ''
      && document.querySelector('textarea[name="memo"]').value !== ''
      && document.querySelector('input[name="agree"]').checked
    ) {
      targetButton.disabled = false;
      targetButton.classList.remove('is-inactive');
      targetButton.classList.add('is-active');
    } else {
      targetButton.disabled = true;
      targetButton.classList.remove('is-active');
      targetButton.classList.add('is-inactive');
    }
  }
}
